import {Inject, Injectable} from "ng-metadata/core";
import {ConfigurationUtil} from "../../../../../nddUtils/configurationUtil.service";
const groupBy = require('lodash/groupBy');

@Injectable()
export class InactiveFacetsMergeLocationFacetsWithinSingleLibraryService{
    constructor(@Inject('$translate') private $translate: ng.translate.ITranslateService, private configurationUtil: ConfigurationUtil){
    }


    public async transform(facetsList){
        if(!this.configurationUtil.isSuprima()){
            return facetsList;
        }
        let locationFacets = facetsList.filter((facetGroup)=> facetGroup.name === 'location_code');
        if (locationFacets.length > 0) {
            locationFacets = locationFacets[0];
            let locationFacetsValues = locationFacets.values;
            let locationRegex = /(.+)–(.+)–(.+)/;
            await this.$translate.onReady();
            let groups = groupBy(locationFacetsValues, (facet) => {
                let match = locationRegex.exec(facet.value);
                if (match){
                    return match[2] + this.$translate.instant('facets.facet.facet_location_code.' + facet.value);
                }
                else {
                    return 'ungrouped';
                }
            });
            locationFacets.values = [];
            for (let key in groups) {
                if (key === 'ungrouped') {
                    locationFacets.values = locationFacets.values.concat(groups[key]);
                }
                else if (groups[key].length > 1) {
                    let facet = groups[key][0];
                    facet.count = groups[key].reduce((sum, currFacet)=>sum + parseInt(currFacet.count), 0);
                    facet.mergedFacets = groups[key].slice(1);
                    locationFacets.values.push(facet);
                }
                else {
                    locationFacets.values = locationFacets.values.concat(groups[key]);
                }
            }
        }
        return facetsList;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetsTransformation/inactiveFacetsTransformations/inactiveFacetsMergeLocationFacetsWithinSingleLibrary/inactiveFacetsMergeLocationFacetsWithinSingleLibrary.service.ts